export default __webpack_public_path__ + "static/media/zero2.41ccbb38.gif";